// config.js
const config = {
  DEV_ENV: "prod",
  DEV_BASE_API_URL: "http://localhost:3015/api",



  PROD_BASE_API_URL: "https://api.testir.xyz/server15/api",




}

export const BASE_API_URL = config.DEV_ENV === "dev" ? config.DEV_BASE_API_URL : config.PROD_BASE_API_URL




export default config
